import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Ocorrencias from './pages/Ocorrencias';
import AnaliseRCA from './pages/AnaliseRCA';
import AcoesCorretivas from './pages/AcoesCorretivas';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/ocorrencias" element={<Ocorrencias />} />
        <Route path="/analise-rca" element={<AnaliseRCA />} />
        <Route path="/acoes-corretivas" element={<AcoesCorretivas />} />
      </Routes>
    </Router>
  );
}

export default App;